import React from 'react'
import { Link } from 'react-router-dom'
export default function AdhanFooter() {
  return (
    <div>
        <div className='flex justify-between items-start px-2 py-4'>
            
            <p className='text-gray-500'>Made with ❤️ aus Deutschland</p>
            <div>
            <Link className='mr-4 text-blue-400' to ="adhan/privacy">Privacy</Link>
            <Link className='mr-4 text-blue-400' to ="adhan/terms">Terms</Link>
            </div>
        </div>
      <p className='text-center text-gray-500'>Copyright © 2024. All rights reserved</p>
    </div>
  )
}
